<!-- RegAlertModal using Profile modal structure -->
<div class="modal-header modal-header-custom">
  <h5 class="modal-title modal-title-custom">Notification</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body modal-body-custom">
  <div class="modal-color modal-color-custom">
    <div class="modal-content-center">
      <div class="img img-wrapper mb-2">
        <i class="fa fa-exclamation-circle text-danger modal-icon-custom"></i>
      </div>
      <div class="field-item user-details pd all-tag-pad">
        <div class="modal-message-custom">Please complete your registration to proceed.</div>
        <div class="col-12 pop-btn-div1">
          <div class="mnag justify-content-center modal-btn-group-custom">
            <button (click)="dismiss()" class="basicbtn declinebtn">Ok</button>
            <button (click)="goToCompleteReg()" class="basicbtn approvebtn ml-2">Complete Registration</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>